import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { IrohDeployInfo, ProjectIdParam } from "@/types"

// Define a service using a base URL and expected endpoints
export const dnsApi = createApi({
  reducerPath: "dns",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}dns`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    dnsGet: build.query<IrohDeployInfo[], ProjectIdParam>({
      query: (params) => ({
        url: `${params.project_id}`,
      }),
    }),
  }),
})

export const { useDnsGetQuery } = dnsApi
